// Libs
import React from 'react'

// CSS
import "./styles.scss"

const MessageCard = ({ gutter, label, role, createBy, status, name, datetime, children }) => {
  let message = ''

  const messageCardStyle = {
    margin: `${gutter / 2}px 0px`,
  }

  // Fix new line bug
  if (children) {
    message = children.replace(/\\n/g, '\n')
  }

  return (
    <div className="message-card" style={messageCardStyle}>
      {label && <p className="message-card__label">{label}</p>}
      <div className={createBy === role ?
        `message-card__content message-card__content--status-${status} message-card__content--sent` :
        `message-card__content message-card__content--status-${status} message-card__content--received`}>
        <div className="message-card__header">
          <p>{name}</p>
        </div>
        <span className="message-card__message">{message}</span>
      </div>
    </div>
  )
}

export default MessageCard
